import { render } from "./EDSAuthModal.vue?vue&type=template&id=0152cde5"
import script from "./EDSAuthModal.vue?vue&type=script&lang=js"
export * from "./EDSAuthModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__